<div class="col-lg-12">
  <div class="row child">
    <span class="d-flex gap-3 align-items-end p-3 globalborder-btm-header">
      <span class="col-auto d-flex gap-3">
        <h2 class="mb-0">Client List</h2>
        <div class="lds-ring inline me-auto ms-2" *ngIf="smallLoader">
          <jni-spinner></jni-spinner>
        </div>
      </span>

      <span class="d-flex align-items-end gap-3">
        <div class="ms-3 nav-link p-0 d-flex align-items-center">
          <a class="link" (click)="onAddClientRelation()">
            <i class="pi pi-plus"></i> Add</a
          >
        </div>
        <div>
          <jni-customer-account
            (customerAccountEvent)="getCustomerAccount($event)"
            (smallLoaderEvent)="getSmallLoaderStatus($event)">
          </jni-customer-account>
        </div>

        <div class="ms-3 nav-link d-flex align-items-center btncommit">
          <a class="link delcol" (click)="onRemoveClientRelation()"
            ><i class="pi pi-trash"></i> Remove</a
          >
        </div>
        <h3 class="mb-0 ms-3" *ngIf="isClientAddAllowed">
          Contact Finance to add Clients
        </h3>
      </span>
    </span>

    <div class="col-12">
      <p-table
        #dt
        stripedRows
        [rows]="10"
        [size]="'small'"
        scrollHeight="300px"
        [value]="clientList"
        [(selection)]="selectedClientList"
        styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        [filterDelay]="0"
        dataKey="salesOrderLine.id"
        editMode="row"
        selectionMode="multiple"
        styleClass="table-listing popuptable">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th class="number">Account</th>
            <th class="notes">Name</th>
            <th class="notes">Default</th>
            <th class="sell-total">AvailableCredit</th>
            <th class="net">Address</th>
            <th class="vendor-sku">Contact</th>
            <th class="notes">BC</th>
            <th class="notes">Billing rep</th>
            <th class="date-time">Last Order</th>
            <th class="sell">Date Added</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-clientList>
          <tr class="p-selectable-row">
            <td style="width: 8rem">
              <p-tableCheckbox
                inputId="account"
                class="me-2"
                (click)="
                  checkboxSelection(clientList.customerAccount)
                "></p-tableCheckbox>
              <a
                class="link"
                (click)="openClientSummaryModal(clientList.customerAccount)"
                >{{ clientList.customerAccount }}</a
              >
            </td>
            <td
              [ngClass]="{
                'trimmeddescription trimmedby40char':
                  organizationNameCharacterCond,
              }"
              class="name">
              {{
                organizationNameCharacterCount(clientList.organizationNameD365)
              }}{{ clientList.organizationNameD365 }}
            </td>
            <td>
              <div class="form-group switcher">
                <div
                  class="form-check form-switch d-flex align-items-center justify-content-between m-0">
                  <p-checkBox
                    type="checkbox"
                    id="flexSwitchCheckDefault"
                    name="flexSwitchCheckDefault"
                    [binary]="true"
                    [(ngModel)]="clientList.defaultClient"
                    (onChange)="
                      onDefaultToogleChange($event, clientList.customerAccount)
                    " />
                </div>
              </div>
            </td>
            <td>
              <span class="credit">{{
                clientList.availableCredit | number: ".2"
              }}</span>
              <span class="ms-2">USD</span>
              <i
                *ngIf="clientList.availableCredit === 0"
                class="icon icon-Error ms-2"></i>
            </td>
            <td>{{ clientList.clientPrimaryAddress }}</td>
            <td>
              <span class="c-title">{{ clientList.primaryContactName }}</span>
              <a
                style="text-decoration: none"
                [title]="clientList.primaryContactNumber"
                [href]="'tel:' + clientList.primaryContactNumber"
                ><i
                  class="icon icon-Call ms-2"
                  *ngIf="clientList.primaryContactNumber">
                </i>
              </a>
              <a
                style="text-decoration: none"
                [title]="clientList.primaryContactEmail"
                [href]="'mailto:' + clientList.primaryContactEmail">
                <i
                  class="icon icon-Email ms-2"
                  *ngIf="clientList.primaryContactEmail">
                </i>
              </a>
            </td>
            <td>{{ clientList.brandingconsultant }}</td>
            <td>{{ clientList.billingRepD365 }}</td>
            <td>
              <a class="link">{{
                clientList?.lastOrderDate | date: "yyyy-MM-dd"
              }}</a>
            </td>
            <td>
              <a class="link">{{
                clientList?.createdDate | date: "yyyy-MM-dd"
              }}</a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20">No clients found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
